import React from 'react';

interface State {
  hasError: boolean;
  error?: Error;
}

// 全局错误边界：任何页面渲染时抛错都不会再整页白屏，
// 而是显示友好提示 + 刷新按钮（便于排查，也让用户能自助恢复）。
export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // 打印到控制台，方便按 F12 把错误贴给开发者排查
    console.error('[ErrorBoundary] 捕获到页面渲染错误:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="max-w-lg w-full bg-white rounded-xl shadow p-6 text-center">
            <div className="text-4xl mb-3">⚠️</div>
            <h2 className="text-lg font-bold text-slate-800 mb-2">页面出现了一点问题</h2>
            <p className="text-sm text-slate-500 mb-4">已为您拦截错误，点击刷新即可恢复。</p>
            <pre className="text-left text-xs bg-slate-100 rounded p-3 mb-4 overflow-auto max-h-40 text-red-600 whitespace-pre-wrap">
              {this.state.error?.message || '未知错误'}
            </pre>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700"
            >
              刷新页面
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
